import { render, staticRenderFns } from "./ProcedimientosQuirurgicos.vue?vue&type=template&id=7bdb8744&scoped=true&lang=pug&"
import script from "./ProcedimientosQuirurgicos.vue?vue&type=script&lang=js&"
export * from "./ProcedimientosQuirurgicos.vue?vue&type=script&lang=js&"
import style0 from "./ProcedimientosQuirurgicos.vue?vue&type=style&index=0&id=7bdb8744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdb8744",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCheckbox,VCol,VContainer,VRow})
